import { TagProps } from '@hdi-seguros/web-components.card';

import { ClaimStates, PolicyStates } from "../../interfaces";
import { getClaimStatesTags } from "./get-claim-states-tags";

import { getPolicyStatesTags } from "./get-policy-states-tags";

//* Agregar aqui todos los tipos posibles de estados.
export type CardTagsStates =  Array<PolicyStates> | Array<ClaimStates>;

const isPolicyStatesArray = (states: CardTagsStates): states is Array<PolicyStates> => {
    return (states as Array<PolicyStates>).every((state: string) => Object.values(PolicyStates).includes(state as PolicyStates))
};

const isClaimStatesArray = (states: CardTagsStates): states is Array<ClaimStates> => {
    return (states as Array<ClaimStates>).every((state: string) => Object.values(ClaimStates).includes(state as ClaimStates))
};

export const getTagsByStates = (states: CardTagsStates = []): Array<TagProps> => {
    if(isPolicyStatesArray(states)) {
        return getPolicyStatesTags(states as Array<PolicyStates>);
    };
    
    if(isClaimStatesArray(states)) {
        return getClaimStatesTags(states as Array<ClaimStates>);
    };

    return [];
};
